const keyById = values => values.reduce((byId, value) => {
  byId[value.id] = value;
  return byId;
}, {});

export default keyById;
